import { Link } from "react-router-dom";
import { Button } from "@components/shadcn-ui/button";
import PermissionWrapper from "features/Permission/PermissionWrapper";
import { Action } from "features/Permission/types";
import { FilePenLine } from "lucide-react";
import { RejectApplicationModal } from "./RejectApplicationButton";
import { encodeURIComponent } from "@lib/utils";
import { ReopenApplicationButton } from "./ReOpenApplicationButton";

interface Application {
  id: string;
  state: string;
}

interface ActionButtonWithPersmission {
  app: any;
}

export const ActionButtonWithPersmission = ({
  app,
}: ActionButtonWithPersmission) => {
  return (
    <div className="flex gap-2">
      {app.state === "REJECTED" ? (
        <ReopenApplicationButton application={app} />
      ) : (
        <RejectApplicationModal application={app} />
      )}

      {/* Upload Document */}
      <Link
        to={`/dashboard/application/uploadDocument/${encodeURIComponent(
          app.id
        )}`}
      >
        <Button
          size="sm"
          className="bg-[#68a4daad] hover:bg-[#89b0d3ad] flex justify-center items-center relative"
        >
          <img src="/assets/uploadFiles.png" className="h-5 w-5" alt="Upload" />
        </Button>
      </Link>

      {/* Edit Application */}
      <PermissionWrapper
        actions={Action.EDIT_APPLICATION}
        applicationStatus={app.state}
        productType={app.product}
      >
        <Link
          to={`/dashboard/application/${encodeURIComponent(
            app.id
          )}?action=edit&id=${app.id}`}
        >
          <Button className="cursor-pointer" size="sm">
            <FilePenLine className="h-4 w-4" />
          </Button>
        </Link>
      </PermissionWrapper>

      {/* Review & Submit */}
      <PermissionWrapper
        actions={Action.SUBMIT_APPLICATION}
        applicationStatus={app.state}
        productType={app.product}
      >
        {({ isAllowed }) =>
          isAllowed && (
            <Link
              to={`/dashboard/application/details/${encodeURIComponent(
                app.id
              )}`}
            >
              <Button size="sm">Review & submit</Button>
            </Link>
          )
        }
      </PermissionWrapper>

      {/* View Application */}
      <PermissionWrapper
        actions={Action.VIEW_APPLICATION}
        applicationStatus={app.state}
        productType={app.product}
      >
        <Link
          to={`/dashboard/application/details/${encodeURIComponent(app.id)}`}
        >
          <Button size="sm">View</Button>
        </Link>
      </PermissionWrapper>

      {/* Soft Approve / Review Application */}
      <PermissionWrapper
        actions={Action.SOFT_APPROVE}
        applicationStatus={app.state}
        productType={app.product}
      >
        <Link
          to={`/dashboard/application/details/${encodeURIComponent(app.id)}`}
        >
          <Button className="cursor-pointer" size="sm">
            Review Application
          </Button>
        </Link>
      </PermissionWrapper>
    </div>
  );
};
